import React from 'react';
import { Card, Col, Row } from 'antd';

import ReasonInput from './input';
import { _getSupplierEmails, _getUserEmails } from '../../services';

class Email extends React.Component {
    render() {
        return (
            <Card
                title="Email">
                <Col span={10}> 
                    <Row>
                        Download <b>supplier</b> emails: 
                        <ReasonInput 
                            onSubmit={this.downloadEmail}
                            emailType="supplier"
                            />
                    </Row>
                    
                    <Row style={{paddingTop: '20px'}}>
                        Download <b>user</b> emails:
                        <ReasonInput 
                            onSubmit={this.downloadEmail}
                            emailType="user"
                            />
                    </Row>            
                </Col>

            </Card>
        )
    }

    downloadEmail = ({ reason, emailType}) => {
        if(emailType === "supplier") {
            _getSupplierEmails( reason )
        } else {
            _getUserEmails( reason )
        }
    }
}

export default Email;


// WEBPACK FOOTER //
// ./src/components/email/index.js